export default __webpack_public_path__ + "static/media/rpc_server.ad83fbd5.svg";